import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import {
    fetchBiometricDevices,
    selectBiometricDevices,
} from '../features/biometric-device/biometric-device.slice';

const useBiometricDevices = () => {
    const dispatch = useAppDispatch();
    const biometricDevices = useAppSelector(selectBiometricDevices);

    const getBiometricDevices = async () => {
        await dispatch(fetchBiometricDevices());
    };

    useEffect(() => {
        if (biometricDevices.length === 0) {
            getBiometricDevices();
        }
    }, []);

    return [biometricDevices];
};

export default useBiometricDevices;
